import ContactUs from '@mindful-web/marko-web-contact-us/browser';
import MonoRail from '@mindful-web/marko-web-theme-monorail/browser';
import Leaders from '@mindful-web/marko-web-leaders/browser';
import PrestitialAd from '@mindful-web/marko-web-prestitial-ad/browser';

const FixedAdBottomHandler = () => import(/* webpackChunkName: "fixed-ad-bottom-handler" */ './fixed-ad-bottom-handler.vue');
const GlobalSponsorSlider = () => import(/* webpackChunkName: "global-sponsor-slider" */ './sponsor-slider.vue');

export default (Browser) => {
  Browser.register('FixedAdBottomHandler', FixedAdBottomHandler);
  Browser.register('GlobalSponsorSlider', GlobalSponsorSlider);

  ContactUs(Browser);
  MonoRail(Browser);
  Leaders(Browser);
  PrestitialAd(Browser);
};
